import {InMemoryCache} from 'apollo-cache-inmemory';
import {ApolloClient} from 'apollo-client';
import {ApolloLink} from 'apollo-link';
import {BatchHttpLink} from 'apollo-link-batch-http';
import Vue from 'vue';
import VueApollo from 'vue-apollo';

const networkLink = ApolloLink.from([
  new BatchHttpLink({
    uri: '/graphql',
    credentials: 'include'
  }),
]);

// Create the apollo client
const apolloClient = new ApolloClient({
  link: networkLink,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      fetchPolicy: 'cache-and-network',
      loadingKey: 'loading',
    },
  },
});

// Install the vue plugin
Vue.use(VueApollo);

Vue.use({
  install(Vue, options) {
    Vue.prototype.$tableDefaultPageSize = 50;
    Vue.prototype.$tableDefaultSmallPageSize = 20;

    Vue.prototype.$mapGraphQLError = function (errorObject) {
      if (
        'graphQLErrors' in errorObject &&
        errorObject.graphQLErrors[0].message === 'validation'
      ) {
        Object.entries(errorObject.graphQLErrors[0].validation).forEach(
          ([key, messages]) => {
            const fieldKey = key.replace(/^input\./, '');
            messages.forEach(message => {
              const field = this.$validator._resolveField(
                fieldKey,
              );
              if (field) {
                field.setFlags({ invalid: true });
                this.errors.add({
                  field: fieldKey,
                  msg: message,
                  id: field.id,
                  scope: field.scope,
                });
              } else {
                console.error(
                  `Unable to resolve field '${fieldKey}' for validation`,
                );
              }
            });
          },
        );
      } else {
        throw errorObject;
      }
    };
  },
});

export {apolloClient, apolloProvider, VueApollo};
